<template>
  <v-container fluid class="jobposting-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/jobposting/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="item_seleted"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="jobpostings-table"
              show-select
              single-select
              item-key="_id"
              sort-by="postingdate"
              sort-desc
              :footer-props="footer"
              :headers="header_items"
              :items="postings"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteJobPosting"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Posting?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_jobposting.jobtitle }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteJobPosting = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteJobPosting(delete_jobposting)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.postingstatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.postingstatus)" small>
                  {{ item.postingstatus }}
                </v-chip>
              </template>
              <template v-slot:item.postingdate="{ item }">
                {{ new Date(item.postingdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.joblocation="{ item }">
                <p class="two-line">{{ item.joblocation }}</p>
                <p class="two-line" v-if="item.departmentid!=undefined">
                  {{ departments.length>0 ? departments.find(i=>i._id == item.departmentid)['departmentname'] : ''  }}
                </p>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editJobPosting(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getStatusColor } from '@/util/tools';

export default {
  name: 'JobPostingList',
  data() {
    return {
      isDeleteJobPosting: false,
      delete_jobposting: {},
      item_seleted: [],
      header_items: [
        { text: 'Post Date', value: 'postingdate' },
        { text: 'Job Title', value: 'jobtitle'},
        { text: 'Location & Deparment', value: 'joblocation'},
        { text: 'Type', value: 'jobtype'},
        { text: 'Status', value: 'postingstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('JobPosting', ['postings', 'isReceiving', 'isDeleting']),
    ...mapState('Department', ['departments']),
  },

  methods: {
    ...mapActions('JobPosting', ["deleteJobPostingRequest","getJobPostingsRequest"]),
    ...mapActions('Department', ['getDepartmentsRequest']),
    editJobPosting(item) {
      this.$router.push({name: 'JobPostingEdit', params: item});
    },
    deleteJobPosting(item) {
      this.isDeleteJobPosting = false;
      this.deleteJobPostingRequest(item);
    },
    deleteDialog(item) {
      this.isDeleteJobPosting = true;
      this.delete_jobposting = {_id: item._id, jobtitle: item.jobtitle};
    },
  },
  async created () {
    await this.getJobPostingsRequest();
    if(this.departments.length==0) await this.getDepartmentsRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
